var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 36,
    viewBox: "0 0 19 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1025 12.102H11.5025V7.701C11.5025 7.11791 11.7339 6.55866 12.146 6.14607C12.558 5.73348 13.1169 5.5013 13.7 5.5005H15.9005V0H11.5025C9.75207 0 8.07334 0.695355 6.8356 1.9331C5.59786 3.17084 4.9025 4.84957 4.9025 6.6V12.102H0.5V17.6025H4.901V35.2065H11.501V17.6025H15.902L18.1025 12.102Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a7100ccf4cb6d7bcf60701f3d0a5dda8.svg";
export { ForwardRef as ReactComponent };